
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      // reveal animation
      const tl = this.$gsap.timeline({ delay: 0.5 })

      tl.from(this.$refs['header-title'], {
        autoAlpha: 0,
        xPercent: -10,
        duration: 0.6,
        ease: 'back',
      })
      // tl.from(this.$refs['header-title'], {
      //   duration: 0.5,
      //   opacity: 0,
      // })
      // tl.from(this.$refs['header-subtitle'], {
      //   duration: 0.4,
      //   opacity: 0,
      // })
      tl.from(this.$refs['header-button'], {
        duration: 0.5,
        autoAlpha: 0,
      })

      const navigation = document.querySelector('#nav-header-pin')

      // change nav bg color when scrolling past Aspot
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '#sections-wwheader',
          start: '-100% top',
          // end: 'bottom bottom',
          // markers: true,
          onEnter: () => {
            navigation.classList.remove('white-bg')
            navigation.classList.add('transparent-bg')
          },
          onLeave: () => {
            navigation.classList.remove('transparent-bg')
            navigation.classList.add('white-bg')
          },
          onEnterBack: () => {
            navigation.classList.remove('white-bg')
            navigation.classList.add('transparent-bg')
          },
          onLeaveBack: () => {
            navigation.classList.remove('transparent-bg')
            navigation.classList.add('white-bg')
          },
        },
      })
    },
  },
}
